const defaultLocale = {
  Select: {
    noOptionsText: 'Nada encontrado',
  },
  FileUpload: {
    placeholder: 'Arraste arquivos pra cá ou',
    placeholderLink: 'clique para procurar',
    removeButton: 'Remover'
  }
}

export default defaultLocale
